var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 300,
    height: 300.00833,
    viewBox: "0 0 299.99998 300.00833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 595.28h841.89V0H0v595.28Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 -424.52 605.652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-91.246c-14.327.019-26.093-11.583-26.114-25.914v-91.246c-.018-14.332 11.585-26.099 25.914-26.118H-.199c14.33-.018 26.091 11.583 26.113 25.917v91.247C25.934-11.782 14.333-.02 0 0",
    style: {
      fill: "#06c755",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.66394 0 0 1.66394 535.697 483.721)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 23.342-23.4 42.332-52.165 42.332-28.761 0-52.164-18.99-52.164-42.332 0-20.926 18.558-38.451 43.626-41.765 1.699-.366 4.011-1.12 4.596-2.572.526-1.319.344-3.385.168-4.717 0 0-.612-3.681-.744-4.465-.227-1.319-1.048-5.158 4.518-2.812 5.568 2.346 30.042 17.689 40.986 30.286h-.002C-3.621-17.755 0-9.342 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.66394 0 0 1.66394 546.028 375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-3.659a1.017 1.017 0 0 1-1.017-1.014v-22.73c0-.56.456-1.014 1.017-1.014H0c.561 0 1.016.454 1.016 1.014v22.73C1.016-.455.561 0 0 0",
    style: {
      fill: "#06c755",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.66394 0 0 1.66394 441.593 393.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-3.659a1.016 1.016 0 0 1-1.016-1.014v-13.504L-15.091-.451c-.024.036-.051.07-.079.103l-.007.006a.914.914 0 0 1-.061.063l-.019.017a.585.585 0 0 1-.054.045c-.008.008-.017.014-.026.021-.018.012-.035.025-.053.036a.192.192 0 0 1-.031.018c-.018.011-.036.022-.054.031-.011.005-.021.011-.032.015-.019.009-.038.018-.058.025l-.033.012a.617.617 0 0 1-.061.019l-.035.01-.058.013a.63.63 0 0 1-.043.005c-.018.004-.036.005-.054.007-.017.002-.034.002-.052.003l-.036.002h-3.658a1.017 1.017 0 0 1-1.017-1.014v-22.73c0-.56.456-1.014 1.017-1.014h3.658c.562 0 1.017.454 1.017 1.014v13.5l10.429-14.085a1.007 1.007 0 0 1 .331-.297l.029-.015a.43.43 0 0 1 .048-.024l.05-.021a1.115 1.115 0 0 1 .099-.034l.015-.003c.083-.022.17-.035.26-.035H0c.562 0 1.016.454 1.016 1.014v22.73C1.016-.455.562 0 0 0",
    style: {
      fill: "#06c755",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.66394 0 0 1.66394 483.5 393.77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-9.942v18.051c0 .561-.455 1.016-1.015 1.016h-3.66a1.016 1.016 0 0 1-1.016-1.016V-4.677c0-.273.109-.52.284-.702l.014-.015.015-.014c.183-.176.429-.284.702-.284H0c.561 0 1.014.456 1.014 1.017v3.659C1.014-.455.561 0 0 0",
    style: {
      fill: "#06c755",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.66394 0 0 1.66394 426.917 362.044)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.561 0 1.014.454 1.014 1.016v3.659c0 .561-.453 1.017-1.014 1.017H-14.619c-.274 0-.521-.11-.704-.287l-.012-.011-.016-.018a1.01 1.01 0 0 1-.282-.7v-22.728a1.01 1.01 0 0 1 .313-.731 1.01 1.01 0 0 1 .701-.284H0c.561 0 1.014.456 1.014 1.016v3.66c0 .56-.453 1.016-1.014 1.016h-9.941v3.842H0c.561 0 1.014.455 1.014 1.016v3.659c0 .561-.453 1.017-1.014 1.017h-9.941V0H0Z",
    style: {
      fill: "#06c755",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.66394 0 0 1.66394 517.122 384.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.c264691f9a96d7ec55780d2e6fbd1c27.svg";
export { ForwardRef as ReactComponent };